import { GET, URLS, POST, PUT, PATCH } from '../../utils'
import { types as LoadingTypes } from './loading'
import { types as ToastTypes } from './toast'

/**
 * Company 公司的状态管理
 */

export const types = {
  /**
   * 关注/粉丝列表请求
   */
  FETCH_LIST_DATA: 'MYFOLLOWER/FETCH_LIST_DATA',

  /**
   * 是否是我的在读学生(是或不是)
   */
  FETCH_IS_MY_STUDENT: 'MYFOLLOWER/FETCH_IS_MY_STUDENT',

  /**
   * 处理点了关注/取关事件
   */
  DEAL_FOLLOW_EVENT: 'MYFOLLOWER/DEAL_FOLLOW_EVENT'
}

const state = {
  // 关注/粉丝列表参数
  page: 1,
  page_size: 10,
  load_more: false,
  data: [],
  total_count: 0
}

const mutations = {
  set_load_more (state, param) {
    // param: {"value": true, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_DATA) {
      state.load_more = param.value
    }
  },
  set_pagenum (state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_DATA) {
      state.page = param.value
    } 
  },
  set_list_data (state, param) {
    // param: {"data": [], "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_DATA) {
      if (state.page === 1) {
        state.data = param.data
      } else {
        state.data = state.data.concat(param.data)
      }
      state.total_count = param.count
    } 
  },
  update_list_data(state, param){
    if (param.data_type === types.FETCH_LIST_DATA) {
      state.data = state.data.map(item=>{
        if(item.pk === param.data.pk){
          return param.data
        }
        return item
      })
    }
  },
  // 处理关注/取关事件
  [types.DEAL_FOLLOW_EVENT](state, param) {
    // {"type":this.type, "user":item.follower.user}
    if(param.type === "fan"){
      // 粉丝列表
      state.data = state.data.map(item=>{
        if(item.owner.user === param.user){
          item["is_follow_owner"] = !item.is_follow_owner
        }
        return item
      })
    }else{
      // 关注列表
      state.data = state.data.filter(item=> item.follower.user !== param.user)
      state.total_count -= 1
    }
  }

}
const actions = {
  /**
     * 关注列表
     * @param {*} param {"page":1, "user_id":"123", "type":"follow/fan"}
     */
  [types.FETCH_LIST_DATA] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types. FETCH_LIST_DATA }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_follower(state.page, param.type, param.user_id)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 是否是在读学员
   * @param {*} param {"user_id":34}
   */
  [types.FETCH_IS_MY_STUDENT]({commit, state}, param){
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types. FETCH_LIST_DATA }
    GET(URLS.is_my_student(param.user_id)).then(response => {
      commit('update_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  }
}
const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}
